import { UnstyledButtonLink } from "~/domains/design-system/Button";
import { Routes } from "~/domains/common/constants/routes";
import LogoText from "~/domains/design-system/vectors/LogoText";
import LogoWhale from "~/domains/design-system/vectors/LogoWhale";

import EnvLabel from "./EnvLabel";
import useStyles from "./Header.styles";

function Logo({ isLoggedIn }: { isLoggedIn?: boolean }) {
  const { cx, classes } = useStyles();

  return (
    <UnstyledButtonLink
      className={cx(classes.logoContainer, { isLoggedIn })}
      href={Routes.home()}
    >
      <LogoWhale />
      <LogoText />
      <EnvLabel />
    </UnstyledButtonLink>
  );
}

export default Logo;
